import { isNil } from 'ramda'

import { getBenefitData } from './getBenefitData'

/** Easily determine whether a policy has a specific benefit included */
export const doesBenefitExist = (policy = {}, benefitType = '') =>
  !isNil(getBenefitData(policy, benefitType))
